import { prop } from '@lib/style/theme';
import { cleanProps } from '@lib/utils';
import { CSSProperties } from 'react';
import { css } from 'styled-components';
import { unitStrict } from '../unit';

export interface PositionProps {
    position: CSSProperties['position'];
    y: CSSProperties['top'];
    t: CSSProperties['top'];
    top: CSSProperties['top'];

    r: CSSProperties['right'];
    right: CSSProperties['right'];

    b: CSSProperties['bottom'];
    bottom: CSSProperties['bottom'];

    x: CSSProperties['left'];
    l: CSSProperties['left'];
    left: CSSProperties['left'];

    z: CSSProperties['zIndex'];
    zIndex: CSSProperties['zIndex'];
}

export type PositionTuple = [
    CSSProperties['top'],
    CSSProperties['right'],
    CSSProperties['bottom'],
    CSSProperties['left'],
];

export const position = (
    pos: PositionProps['position'],
    posAxes?: PositionTuple,
    zIndex: CSSProperties['zIndex'] = 1,
): any => {
    const [top, right, bottom, left] = posAxes || [];

    return css`
        && {
            position: ${prop(['position'], pos)};
            top: ${prop(['y', 't', 'top'], top, unitStrict)};
            right: ${prop(['r', 'right'], right, unitStrict)};
            bottom: ${prop(['b', 'bottom'], bottom, unitStrict)};
            left: ${prop(['x', 'l', 'left'], left, unitStrict)};
            z-index: ${prop(['z', 'zIndex'], zIndex)};
        }
    `;
};

position.clean = (props) =>
    cleanProps(props, ['position', 'z', 'zIndex', 'y', 't', 'top', 'r', 'right', 'b', 'bottom', 'x', 'l', 'left']);
